/* eslint-disable */
import React, { Component } from "react";
import { withRouter } from "../../../withRouter";
import { connect } from "react-redux";
import cookie from "react-cookies";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { apiUrl, adminlimit } from "../../Helpers/Config";
import { GET_LISTDATA } from "../../../actions";
import {
  decodeValue,
  removeItem,
  showDateTime,
  showPriceValue,
} from "../../Helpers/SettingHelper";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
var module = "reports/";
var moduleName = "Payments Summary Report";
class List extends Component {
  constructor(props) {
    super(props);
    var companyID = cookie.load("companyID");
    this.state = {
      companyID: companyID,
      path: this.props?.location?.pathname || '',
      totalRecords: 0,
      totalTransactionValue:0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      loading: true,
      user: "",
      start_date: "",
      end_date: "",
      searchkeywords: "",
      exportUrl: "",
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }
  componentDidMount() {
    this.loadList(1);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
        totalTransactionValue: nextProps.totalTransactionValue,
      });
    }
  }

  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        function () {
          this.loadList(value);
        }
      );
    }
  };
  removeItem(deleteID) {
    var params = { delete_id: deleteID, company_id: this.state.companyID };
    var delurl = module + "delete";
    removeItem(params, delurl, "client");
  }
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }

  handleChangeDate(name, value) {
    this.setState({ [name]: value });
  }

  searchList() {
    this.setState({ loading: true }, function () {
      this.loadList(1);
    });
  }
  loadList(offset) {
    var addParams = "";

    if (this.state.searchkeywords !== "") {
      addParams += "&name=" + this.state.searchkeywords;
    }
    if (this.state.start_date !== "" && this.state.end_date !== "") {
      addParams +=
        "&from_date=" +
        moment(this.state.start_date).format("Y-MM-DD HH:mm:ss") +
        "&to_date=" +
        moment(this.state.end_date).format("Y-MM-DD HH:mm:ss");
    } else if (this.state.start_date !== "" && this.state.end_date !== "") {
      addParams +=
        "&from_date=" +
        moment(this.state.start_date).format("Y-MM-DD HH:mm:ss");
    }

    var params = {
      params: "limit=" + adminlimit + "&offset=" + offset + addParams,
      url: apiUrl + module + "billpay",
      authType: "client",
    };
    var exportUrl =
      apiUrl +
      module +
      "billpay/export?companyID=" +
      this.state.companyID +
      addParams;
    this.setState({ exportUrl: exportUrl });
    this.props.getListData(params);
  }
  resetSearch() {
    this.setState(
      {
        loading: true,
        name: "",
        start_date: "",
        end_date: "",
      },
      function () {
        this.loadList(1);
      }
    );
  }

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"bill-pay-report"} />
          <div className="layout-page">
            <Topmenu />

            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">{moduleName}</h4>
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col-md-3">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="searchkeywords"
                        onChange={this.handleChangeText}
                        placeholder="Search Keywords"
                        value={this.state.searchkeywords}
                      />
                      <label htmlFor="name">Search</label>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-floating form-floating-outline mb-4">
                      <DatePicker
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        showTimeSelect
                        dropdownMode="select"
                        className="form-control"
                        selected={this.state.start_date}
                        dateFormat="d-MM-yyyy h:mm aa"
                        placeholderText="Start Date"
                        onChange={this.handleChangeDate.bind(
                          this,
                          "start_date"
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-floating form-floating-outline mb-4">
                      <DatePicker
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        showTimeSelect
                        dropdownMode="select"
                        className="form-control"
                        selected={this.state.end_date}
                        minDate={
                          this.state.start_date !== ""
                            ? this.state.start_date
                            : ""
                        }
                        dateFormat="d-MM-yyyy h:mm aa"
                        placeholderText="End Date"
                        onChange={this.handleChangeDate.bind(this, "end_date")}
                      />
                    </div>
                  </div>
                  <div className="col-md-4 mt-2">
                    <button
                      type="button"
                      className="btn btn-primary me-sm-3 me-1 waves-effect waves-light"
                      onClick={this.searchList.bind(this)}
                    >
                      Search
                    </button>
                    <button
                      type="reset"
                      className="btn btn-label-secondary waves-effect me-sm-3 me-1"
                      onClick={this.resetSearch.bind(this)}
                    >
                      Reset
                    </button>
                    {this.state.listdata.length > 0 &&
                      this.state.exportUrl !== "" && (
                        <a href={this.state.exportUrl} target="_blank">
                          <button
                            type="button"
                            className="btn btn-info waves-effect waves-light"
                          >
                            Export
                          </button>
                        </a>
                      )}
                  </div>
                </div>
                <div className="card mb-2">
                  <div className="card-body pb-1">
                    <ul
                      class="nav nav-tabs nav-tabs-widget pb-3 gap-4 mx-1 d-flex flex-nowrap"
                      role="tablist"
                    >
                      <li class="nav-item" role="presentation">
                        <a
                          href="javascript:void(0);"
                          class="nav-link btn d-flex flex-column align-items-center justify-content-center active"
                          role="tab"
                          data-bs-toggle="tab"
                          data-bs-target="#navs-orders-id"
                          aria-controls="navs-orders-id"
                          aria-selected="true"
                        >
                          <div class="avatar">
                            <div class="avatar-initial bg-label-secondary rounded">
                              {this.state.totalRecords}
                            </div>
                          </div>
                          Total Number <br />
                          of transaction
                        </a>
                      </li>
                      <li class="nav-item" role="presentation">
                        <a
                          href="javascript:void(0);"
                          class="nav-link btn d-flex flex-column align-items-center justify-content-center active"
                          role="tab"
                          data-bs-toggle="tab"
                          data-bs-target="#navs-sales-id"
                          aria-controls="navs-sales-id"
                          aria-selected="false"
                          tabindex="-1"
                        >
                          <div class="avatar">
                            <div class="avatar-initial bg-label-secondary rounded">
                              {showPriceValue(this.state.totalTransactionValue)}
                            </div>
                          </div>
                          Total Transaction<br/> Value
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="card">
                  <div className="table-responsive text-nowrap p-1 mt-4">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Transaction ID</th>
                          <th>Customer Name</th>
                          <th>Customer Email</th>
                          <th>Customer Phone</th>
                          <th>Payment Type</th>
                          <th>Bill Amount</th>
                          <th>Voucher Amount</th>
                          <th>Bill Pay Date</th>
                          <th>Cancelled Bill</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loading === true ? (
                          <tr>
                            <td colSpan={6} align="center">
                              <div
                                className="spinner-border spinner-border-lg text-primary"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </td>
                          </tr>
                        ) : this.state.listdata.length > 0 ? (
                          this.state.listdata.map((item, index) => {
                            var customer = item?.customer || "";
                            var customerdefault =
                              customer.customerdefault ?? "";
                            var customerName = customer.customerName ?? "";
                            var customerEmail = customer.customerEmail ?? "";
                            var customerPhone = customer.customerPhone ?? "";
                            var cancellTransactoinID =
                              item.cancellTransactoinID ?? "";
                            return (
                              <tr
                                key={index}
                                className={
                                  cancellTransactoinID !== ""
                                    ? "table-danger"
                                    : ""
                                }
                              >
                                <td>
                                  <strong>{item.transactionID}</strong>
                                </td>
                                <td>
                                  <strong>
                                    {customerdefault === 1 || customerName == ""
                                      ? "Guest"
                                      : customerName}
                                  </strong>
                                </td>
                                <td>
                                  {customerdefault === 1 || customerEmail == ""
                                    ? ""
                                    : customerEmail}
                                </td>
                                <td>
                                  {customerdefault === 1 || customerPhone == ""
                                    ? ""
                                    : customerPhone}
                                </td>
                                
                                <td>
                                  {item.transQRType}
                                </td>
                                <td>
                                  {showPriceValue(item.transQRUseredAmount)}
                                </td>
                                <td>
                                  {showPriceValue(item.transProductPrice)}
                                </td>
                                <td>{showDateTime(item.createdAt)}</td>
                                <td>{cancellTransactoinID}</td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td className="text-center" colSpan={8}>
                              No {moduleName} Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagenation
                    params={{
                      totalRecords: this.state.totalRecords,
                      totalPage: this.state.totalPage,
                      currentPage: this.state.currentPage,
                    }}
                    sateValChange={this.sateValChange}
                  />
                </div>
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>

        <div className="drag-target"></div>
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var listdata = Array();
  var listdataStatus = "";
  var totalPages = 0;
  var totalRecords = 0;
  var totalTransactionValue = 0;
  if (Object.keys(state.listdata).length > 0) {
    listdataStatus = state.listdata[0].status;
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
      totalTransactionValue = state.listdata[0].totalTransactionValue;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
    totalTransactionValue:totalTransactionValue
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(List));
